// SVG chart primitives: donut + legend row. Pure SVG, token-colored, no deps.
// Ported from botriq-admin-fe's Robot Portal UI kit (AreaChart/BatteryDistribution
// omitted — not used by this project yet).
import PropTypes from "prop-types";
import { v4 as uuidv4 } from "uuid";

export const Legend = ({ color, label, value }) => (
  <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
    <span style={{ width: 8, height: 8, borderRadius: 2, background: color, flex: "none" }} />
    <span style={{ fontSize: 12, color: "var(--bq-text2)", flex: 1 }}>{label}</span>
    <span style={{ fontSize: 12.5, fontWeight: 600, fontVariantNumeric: "tabular-nums" }}>
      {value}
    </span>
  </div>
);
Legend.propTypes = { color: PropTypes.string, label: PropTypes.node, value: PropTypes.node };

// segs: [[value, color], ...]
export const Donut = ({ segs = [], size = 96 }) => {
  const s = segs.filter((x) => x && x[0] > 0);
  const sum = s.reduce((acc, [v]) => acc + v, 0);
  const total = sum || 1;
  const r = size / 2 - 9;
  const cx = size / 2,
    cy = size / 2;
  const C = 2 * Math.PI * r;
  let off = 0;
  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      style={{ flex: "none", transform: "rotate(-90deg)" }}
    >
      <circle cx={cx} cy={cy} r={r} fill="none" stroke="var(--bq-surface3)" strokeWidth={9} />
      {s.map(([v, c]) => {
        const len = C * (v / total);
        const el = (
          <circle
            key={uuidv4()}
            cx={cx}
            cy={cy}
            r={r}
            fill="none"
            stroke={c}
            strokeWidth={9}
            strokeDasharray={`${len} ${C - len}`}
            strokeDashoffset={-off}
          />
        );
        off += len;
        return el;
      })}
      <text
        x={cx}
        y={cy}
        transform={`rotate(90 ${cx} ${cy})`}
        textAnchor="middle"
        dominantBaseline="central"
        fontSize={sum ? 19 : 14}
        fontWeight={700}
        fill={sum ? "var(--bq-text)" : "var(--bq-text3)"}
      >
        {sum || "—"}
      </text>
    </svg>
  );
};
Donut.propTypes = { segs: PropTypes.array, size: PropTypes.number };
